import { useEffect, useState } from "react";
import { BounceLoader } from "react-spinners";
import { FileType } from "../helpers/types";
import { useAuthContext } from "../providers/AuthProvider";

const MediaBox = (props: FileType) => {
  const { show_url, video_uid, url } = props;
  const { apiCall } = useAuthContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [thumbnail, setThumbnail] = useState<string | null>(null);

  const handleImageLoad = () => setIsLoading(false);
  const handleImageError = () => setIsLoading(false);

  const pollForResponse = async () => {
    const maxAttempts = 10;
    const interval = 3000;
    let attempts = 0;

    const checkResponse = async () => {
      try {
        const response = await apiCall({
          action: "checkVideoUploadStatus",
          video_uid,
        });

        if (response?.data?.status === 200) {
          setThumbnail(response.data.thumbnail);
          return;
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkResponse, interval);
        } else {
          console.error(
            "Max attempts reached. Upload processing not completed.",
          );
        }
      } catch (error) {
        console.error("Error checking upload status: ", error);
      }
    };

    checkResponse();
  };

  useEffect(() => {
    if (video_uid) {
      pollForResponse();
    }
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center media-box">
      {isLoading && <BounceLoader color="#DEE2E6" size={50} />}

      <img
        src={
          video_uid
            ? thumbnail ||
              `https://videodelivery.net/${video_uid}/thumbnails/thumbnail.jpg?time=1s`
            : import.meta.env.VITE_API_BASE_URL + show_url
        }
        onLoad={handleImageLoad}
        onError={handleImageError}
        className={isLoading ? "d-none" : "d-inline-block"}
      />
    </div>
  );
};

export default MediaBox;
